export const USER_LICENSE_TYPE = {
  lite: "lite",
  trial: "trial",
  premium: "premium",
  essentials: "essentials",
  nce: "nce",
} as const;

export const USER_LICENSE_TYPES = Object.values(USER_LICENSE_TYPE);

export const COMPLETED_ONBOARDING_EVENT_NAME = {
  INITIAL: "initial_teacher_onboarding_completed",
  REPEAT: "repeat_teacher_onboarding_completed",
};

export const PREMIUM_STEPS = {
  createAccount: "Create account", // 0
  meetNewsela: "Meet Newsela", // 1
  addClasses: "Add classes", // 2
  chooseTopics: "Choose topics", // 3
};

export const PREMIUM_STEPS_LIST = Object.values(PREMIUM_STEPS);

export const LICENSE_TO_FEEDBACK_FORM_MAP = {
  [USER_LICENSE_TYPE.premium]:
    "https://newselamarketing.typeform.com/to/eof6NjSh",
  [USER_LICENSE_TYPE.trial]:
    "https://newselamarketing.typeform.com/to/ZF954Awo",
};

export const NEEDS_ACTIVE_SESSION_RECORD_EVENT = "user_active_session";

export const LEVEL_0_TAXONOMY_IDS: Record<
  "ela" | "social_studies" | "science",
  string
> = {
  ela: "clt5v9pa1000058906kihkg33",
  social_studies: "clsm7w5t60001cd908iwywkyp",
  science: "clsm7xcez0001qt90w481x4oj",
} as const;
export const ADMIN_REFERRAL_COMPLETED_EVENT = "admin_referral_completed";
export const VISIT_NEWSELA_CALENDAR_COMPLETED_EVENT =
  "visit_newsela_calendar_completed";
